const Arrow = ({ width = 24, height = 24, color = '#000000', rotate = 0, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{
        transform: `rotate(${rotate}deg)`,
        display: 'inline-block',
      }}
      {...props}>
      <path
        d="M8.91421 3.08188L7.5 4.49609L14.5711 11.5672L15.9853 11.5672L15.9853 10.1529L8.91421 3.08188Z"
        fill={color}
      />
      <path
        d="M8.91421 20.9181L7.5 19.5039L14.5711 12.4328L15.9853 12.4328L15.9853 13.8471L8.91421 20.9181Z"
        fill={color}
      />
    </svg>
  )
}

export default Arrow
